import * as React from 'react';

import {Button} from 'shells/button/button';
import {Body} from 'shells/typography/body';
import {Title} from 'shells/typography/title';

import {openOauthWindow} from '../../../oauth/open-oauth-window';

import styles from './quickbooks-popover.module.css';

export function QuickbooksConnectCTA({
    canAccessIntegrations,
    onClick,
}: {
    canAccessIntegrations: boolean;
    onClick: () => void;
}) {
    return (
        <div className={styles['cta-container']}>
            <div className={styles['logo-title']}>
                <img
                    src='/include/images/integration-logos/quickbooks.png'
                    height={42}
                    style={{marginRight: 8}}
                />
                <Title>Create Quickbook invoices from Nutshell leads!</Title>
            </div>
            <Body>
                Connect to Quickbooks to easily create a Quickbooks invoice right from a Nutshell
                lead! Or, create a customer in Quickbooks from a Nutshell person or company page.
            </Body>
            {canAccessIntegrations ? (
                <Button variant='primary' onClick={onClick} size='big'>
                    Connect to Quickbooks
                </Button>
            ) : (
                <Body>
                    <i>Ask your administrator to set up your Quickbooks to enable this feature!</i>
                </Body>
            )}
        </div>
    );
}

export function handleCtaClick() {
    const windowFeatures = {
        width: 600,
        height: 600,
        toolbar: 'no',
        location: 'no',
        alwaysRaised: 'yes',
    } as const;

    return openOauthWindow(
        '/setup/instant-integration/edit-quickbooks?redirect=%2Fsetup%2Fintegration%2Fquickbooks-popup-callback',
        'Quickbooks',
        windowFeatures
    );
}
